var map = {
	"../../../pages/qr-code/qr-code.module.ngfactory": [
		"tc7m",
		13
	],
	"../../../pages/scan-qrcode/scan-qrcode.module.ngfactory": [
		"y9Di",
		29
	],
	"../../../pages/verify-table-code/verify-table-code.module.ngfactory": [
		"qgHt",
		41
	],
	"../brand-faq/brand-faq.module.ngfactory": [
		"0+al",
		30
	],
	"../brand-store-list/brand-store-list.module.ngfactory": [
		"+zm+",
		0,
		15
	],
	"../dinein-or-takeaway-page/dinein-or-takeaway-page.module.ngfactory": [
		"SQAv",
		38
	],
	"../item-grid/item-grid.module.ngfactory": [
		"AD3b",
		1,
		0,
		16
	],
	"../modifier-item-select/modifier-item-select.module.ngfactory": [
		"LSuu",
		18
	],
	"../pages/category-group-list/category-group-list.module.ngfactory": [
		"L+vw",
		1,
		0,
		32
	],
	"../pages/category-item-list/category-item-list.module.ngfactory": [
		"G7ku",
		1,
		0,
		33
	],
	"../pages/category-list/category-list.module.ngfactory": [
		"7gFu",
		1,
		0,
		34
	],
	"../pages/item-grid/item-grid.module.ngfactory": [
		"AD3b",
		1,
		0,
		16
	],
	"../pages/qr-code/qr-code.module.ngfactory": [
		"tc7m",
		13
	],
	"../pages/search-item/search-item.module.ngfactory": [
		"0iv1",
		1,
		0,
		39
	],
	"../pages/side-menu-category-list/side-menu-category-list-page.module.ngfactory": [
		"cko/",
		1,
		0,
		40
	],
	"./alipay-payment/alipay-payment.module.ngfactory": [
		"YWD8",
		0,
		43
	],
	"./byod-summary/byod-summary.module.ngfactory": [
		"eF/a",
		2,
		0,
		19
	],
	"./cart/cart.module.ngfactory": [
		"cYNU",
		1,
		2,
		0,
		42
	],
	"./cart/multi-order-cart/multi-order-cart.module.ngfactory": [
		"TEWH",
		1,
		2,
		0,
		17
	],
	"./credit-card-payment/credit-card-payment.module.ngfactory": [
		"Xeyw",
		0,
		44
	],
	"./eft-payment/eft-payment.module.ngfactory": [
		"N8o6",
		0,
		45
	],
	"./login/login.module.ngfactory": [
		"Q9+5",
		0,
		60
	],
	"./member-reward/member-reward.module.ngfactory": [
		"Jx/8",
		0,
		25
	],
	"./modifier-item-select/modifier-item-select.module.ngfactory": [
		"LSuu",
		18
	],
	"./mpgs-apple-pay-payment/mpgs-apple-pay-payment.module.ngfactory": [
		"z8L2",
		2,
		0,
		46
	],
	"./mpgs-credit-card-payment/mpgs-credit-card-payment.module.ngfactory": [
		"Lijj",
		0,
		47
	],
	"./mpgs-google-pay-payment/mpgs-google-pay-payment.module.ngfactory": [
		"sM2/",
		0,
		28
	],
	"./mpgs-host-session/mpgs-host-session.module.ngfactory": [
		"xbH0",
		0,
		48
	],
	"./multi-order-cart/multi-order-cart.module.ngfactory": [
		"TEWH",
		1,
		2,
		0,
		17
	],
	"./multi-order-detail/multi-order-detail.module.ngfactory": [
		"uh18",
		65
	],
	"./multi-order-history/multi-order-history.module.ngfactory": [
		"dKBQ",
		0,
		14
	],
	"./oepay-payment/oepay-payment.module.ngfactory": [
		"9qj0",
		2,
		0,
		49
	],
	"./openrice-payment/openrice-payment.module.ngfactory": [
		"SryB",
		0,
		50
	],
	"./order-detail/order-detail.module.ngfactory": [
		"JSSb",
		66
	],
	"./order-status/order-status.module.ngfactory": [
		"6Dmw",
		12,
		0,
		20
	],
	"./pages/brand-store-list/brand-store-list.module.ngfactory": [
		"+zm+",
		0,
		15
	],
	"./pages/byod-brand-splash/byod-brand-splash.module.ngfactory": [
		"8d1I",
		0,
		24
	],
	"./pages/byod-splash/byod-splash.module.ngfactory": [
		"gc8Q",
		12,
		0,
		31
	],
	"./pages/close/close.module.ngfactory": [
		"5pCk",
		35
	],
	"./pages/code/code-page.module.ngfactory": [
		"zSQ6",
		36
	],
	"./pages/delivery-information/delivery-information.module.ngfactory": [
		"WYxV",
		0,
		37
	],
	"./pages/test/test.module.ngfactory": [
		"Qy1k",
		0,
		27
	],
	"./pop-up-set-menu-withImg/pop-up-set-menu-withImg-page.module.ngfactory": [
		"IOuC",
		0,
		57
	],
	"./pop-up-set-menu/pop-up-set-menu.module.ngfactory": [
		"ouWR",
		0,
		58
	],
	"./profile/profile.module.ngfactory": [
		"p6xJ",
		61
	],
	"./redirect-payment/redirect-payment.module.ngfactory": [
		"sJc6",
		0,
		51
	],
	"./registration/registration.module.ngfactory": [
		"JWRA",
		0,
		62
	],
	"./reset-password/reset-password.module.ngfactory": [
		"OIZK",
		63
	],
	"./reward-list/reward-list.module.ngfactory": [
		"Xwuq",
		0,
		26
	],
	"./routes/summary/byod-summary/byod-summary.module.ngfactory": [
		"eF/a",
		2,
		0,
		19
	],
	"./routes/summary/multi-order-history/multi-order-history.module.ngfactory": [
		"dKBQ",
		0,
		14
	],
	"./routes/summary/order-status/order-status.module.ngfactory": [
		"6Dmw",
		12,
		0,
		20
	],
	"./saved-order-list/saved-order-list.module.ngfactory": [
		"QSay",
		68
	],
	"./set-sub-items/set-sub-items.module.ngfactory": [
		"UlqU",
		59
	],
	"./stripe-apple-payment/stripe-apple-payment.module.ngfactory": [
		"atIV",
		2,
		0,
		52
	],
	"./stripe-google-pay-payment/stripe-google-pay-payment.module.ngfactory": [
		"AXia",
		0,
		53
	],
	"./summary-list/summary-list.module.ngfactory": [
		"UMUz",
		0,
		69
	],
	"./summary/order-status-prekiosk/order-status-prekiosk.module.ngfactory": [
		"SHII",
		67
	],
	"./verify-registration/verify-registration.module.ngfactory": [
		"JMPQ",
		64
	],
	"./wechat-open-payment/wechat-open-payment.module.ngfactory": [
		"xCDo",
		0,
		54
	],
	"./wechat-pay-payment/wechat-pay-payment.module.ngfactory": [
		"+iLe",
		0,
		55
	],
	"./wirecard-v2-payment/wirecard-v2-payment.module.ngfactory": [
		"TvEs",
		0,
		56
	],
	"src/app/pages/qr-code/qr-code.module.ngfactory": [
		"tc7m",
		13
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "crnd";
module.exports = webpackAsyncContext;